var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.capitalized)+"\n  "),(!_vm.capitalized && _vm.col.dashIfEmpty)?[_c('span',{staticClass:"text-muted"},[_vm._v("—")])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }